import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DownIcon from '@components/SvgComponents/DownIcon';
import UpIcon from '@components/SvgComponents/UpIcon';
import RightIcon from '@components/SvgComponents/RightIcon';

interface HelpAndSupportTableProps {
    data: {
        uuid: string;
        answer: string;
        question: string;
        sort_order: number;
    }[];
    setCardVisible: (visible: boolean) => void;
}

const HelpAndSupportTable: React.FC<HelpAndSupportTableProps> = ({
    data,
    setCardVisible,
}) => {
    const { t } = useTranslation();
    const [expandedRow, setExpandedRow] = useState<string | null>(null);

    const sortedData = [...data].sort((a, b) => a.sort_order - b.sort_order);

    const toggleRow = (uuid: string) => {
        setExpandedRow((prev) => {
            if (prev === uuid) {
                setCardVisible(true);
                return null;
            }
            setCardVisible(false);
            return uuid;
        });
    };

    return (
        <div
            className="card rounded-2xl mt-5 w-10/12 mx-auto border-none"
            style={{ overflow: 'auto' }}
        >
            <div className="card-datatable table-responsive border-none">
                <table className="datatables-users table border-none">
                    <tbody>
                        {sortedData.map((item) => (
                            <React.Fragment key={item.uuid}>
                                <tr
                                    className="cursor-pointer"
                                    onClick={() => toggleRow(item.uuid)}
                                >
                                    <td className="border-none">
                                        <div className="flex justify-between items-center text-black">
                                            <p className="font-semibold">
                                                {item.question}
                                            </p>
                                            <span className="text-lg">
                                                {expandedRow === item.uuid ? (
                                                    <UpIcon />
                                                ) : (
                                                    <RightIcon />
                                                )}
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                {expandedRow === item.uuid && (
                                    <tr>
                                        <td className="border-none">
                                            <div
                                                className="my-2 ml-5 text-black"
                                                dangerouslySetInnerHTML={{
                                                    __html: item.answer,
                                                }}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
export default HelpAndSupportTable;
